"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextBox = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _utils = require("../../../utils");
var _Button = require("../Button");
var _Title = require("../Title");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const TextBox = ({
  className,
  module,
  textMaxLines,
  titleMaxLines,
  titleVariant
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (module == null) {
    return null;
  }
  const {
    content,
    link
  } = module;
  if (!content) {
    return null;
  }
  const {
    textCollection,
    title,
    titleStorybookColor
  } = content;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.TEXT_BOX),
    className: className,
    children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Title.Title, {
      maxLines: titleMaxLines,
      title: title,
      titleVariant: titleVariant,
      color: titleStorybookColor
    }) : null, textCollection && textCollection.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TextWrapper, {
      children: textCollection.map((text, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledTextWithHtml, {
        html: (0, _utils.transformHtmlContent)(text),
        maxLines: textMaxLines,
        elementsProps: _constants.elementsProps
      }, (0, _utils.getKey)('text', index)))
    }) : null, link ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
      link: link
    }) : null]
  });
};
exports.TextBox = TextBox;
